import {Component, OnDestroy} from '@angular/core';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {User} from '../../../../../models/user';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-purpose-type-page',
  templateUrl: './purpose-type-page.component.html',
  styleUrls: ['./purpose-type-page.component.scss']
})
export class PurposeTypePageComponent implements OnDestroy {

  userModel: User;
  private subscription = new Subscription();

  constructor(service: BusinessDataService) {
    this.subscription.add(service.GetUser().subscribe(u => this.userModel = u.model));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
